const VALIDATION_CONSTRAINTS = {
	overview: {
		minLength: 10,
		maxLength: 500,
	},
	challenges: {
		minCount: 1,
		maxCount: 10,
		minLength: 5,
		maxLength: 200,
	},
}

interface ValidationResult {
	error?: string
	isValid: boolean
}

export const validatePersonaInput = (
	overview: string,
	challenges: string[]
): ValidationResult => {
	// Validate overview
	const overviewResult = validateOverview(overview)
	if (!overviewResult.isValid) {
		return overviewResult
	}

	// Validate challenges
	const challengesResult = validateChallenges(challenges)
	if (!challengesResult.isValid) {
		return challengesResult
	}

	return { isValid: true }
}

const validateOverview = (overview: string): ValidationResult => {
	const trimmedOverview = overview.trim()
	if (trimmedOverview.length < VALIDATION_CONSTRAINTS.overview.minLength) {
		return {
			isValid: false,
			error: `Overview must be at least ${VALIDATION_CONSTRAINTS.overview.minLength} characters`,
		}
	}
	if (trimmedOverview.length > VALIDATION_CONSTRAINTS.overview.maxLength) {
		return {
			isValid: false,
			error: `Overview must not exceed ${VALIDATION_CONSTRAINTS.overview.maxLength} characters`,
		}
	}

	return { isValid: true }
}

const validateChallenges = (challenges: string[]): ValidationResult => {
	const validChallenges = challenges.filter(
		(challenge) => challenge.trim().length > 0
	)

	if (validChallenges.length < VALIDATION_CONSTRAINTS.challenges.minCount) {
		return {
			isValid: false,
			error: `At least ${VALIDATION_CONSTRAINTS.challenges.minCount} challenge is required`,
		}
	}

	if (validChallenges.length > VALIDATION_CONSTRAINTS.challenges.maxCount) {
		return {
			isValid: false,
			error: `Maximum ${VALIDATION_CONSTRAINTS.challenges.maxCount} challenges allowed`,
		}
	}

	for (const challenge of validChallenges) {
		const trimmedChallenge = challenge.trim()
		if (
			trimmedChallenge.length <
			VALIDATION_CONSTRAINTS.challenges.minLength
		) {
			return {
				isValid: false,
				error: `Each challenge must be at least ${VALIDATION_CONSTRAINTS.challenges.minLength} characters`,
			}
		}
		if (
			trimmedChallenge.length >
			VALIDATION_CONSTRAINTS.challenges.maxLength
		) {
			return {
				isValid: false,
				error: `Each challenge must not exceed ${VALIDATION_CONSTRAINTS.challenges.maxLength} characters`,
			}
		}
	}

	return { isValid: true }
}
